var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoheader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 75,
    viewBox: "0 0 66 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7377 1.04004C35.4058 1.04004 37.5629 3.19711 37.5629 5.86523V10.8574C37.5629 11.3902 38.0028 11.8308 38.5355 11.8311C39.0684 11.8311 39.5092 11.3903 39.5092 10.8574C39.5093 8.18945 41.6663 6.0332 44.3344 6.0332C47.0022 6.03335 49.1584 8.18954 49.1586 10.8574V35.8418C49.1586 36.1293 49.2834 36.3997 49.5072 36.5938L49.6088 36.6729L49.6136 36.6758C49.7341 36.7586 49.9028 36.8154 50.1322 36.8154C50.2717 36.8154 50.418 36.7842 50.5375 36.7344C51.9022 36.134 53.4281 35.8291 54.9838 35.8291C57.4376 35.8291 59.8074 36.5507 61.6888 37.8945L63.2494 39.0098L61.4633 39.709C60.1248 40.2336 58.7166 41.1381 57.6957 42.7568C56.6827 44.3663 55.3583 47.5311 54.1849 50.6162C53.0387 53.63 52.0763 56.4601 51.7552 57.4316C51.7483 57.4593 51.7417 57.487 51.7347 57.5146C51.7275 57.5435 51.7205 57.5727 51.7133 57.6016C49.9585 66.602 41.96 73.1201 32.7777 73.1201C23.63 73.1199 15.6335 66.6354 13.7816 57.6748H13.7806C13.7778 57.663 13.7761 57.6548 13.7738 57.6455C13.7719 57.6375 13.7702 57.6311 13.7689 57.626L13.7562 57.6016L13.7328 57.5312C13.5334 56.933 12.5773 54.0884 11.3939 50.9561C10.1969 47.7877 8.81186 44.4459 7.76013 42.7783C6.73737 41.156 5.34767 40.2539 3.99646 39.7314L2.18591 39.0312L3.77185 37.9111C5.66835 36.5725 8.01428 35.8487 10.4711 35.8486C11.935 35.8486 13.3928 36.1193 14.6996 36.6533L14.9594 36.7637L14.9662 36.7666L14.974 36.7695C15.1074 36.8311 15.221 36.8554 15.3431 36.8555C15.501 36.8555 15.6921 36.8046 15.8939 36.6914C16.1641 36.4955 16.3168 36.1996 16.3168 35.8818V10.8779C16.3168 8.2098 18.4738 6.05273 21.142 6.05273C23.81 6.0529 25.9662 8.2099 25.9662 10.8779C25.9662 11.4108 26.4069 11.8516 26.9398 11.8516C27.4727 11.8515 27.9134 11.4108 27.9135 10.8779V5.86523C27.9135 3.19717 30.0696 1.04015 32.7377 1.04004Z",
    fill: "#0072A3",
    stroke: "#003B75",
    strokeWidth: 2.07997
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8057 7.54736C35.0759 7.54736 36.8995 9.3932 36.8995 11.6616V15.7163C36.8995 16.0477 37.1718 16.312 37.4844 16.312C37.7969 16.3118 38.0684 16.0476 38.0684 15.7163C38.0685 13.448 39.8921 11.6022 42.1622 11.6021C44.4323 11.6021 46.2558 13.4479 46.2559 15.7163V36.0083C46.256 36.186 46.3319 36.3533 46.4708 36.4741L46.5342 36.5229L46.5391 36.5259V36.5269C46.5971 36.5669 46.6908 36.603 46.8409 36.603C46.9249 36.603 47.0156 36.5835 47.088 36.5532C48.2161 36.0544 49.4752 35.8022 50.7559 35.8022C52.7755 35.8023 54.7295 36.4003 56.2842 37.5181L57.8321 38.6304L56.0587 39.3296C55.0086 39.7438 53.9117 40.4556 53.1153 41.7271L53.1143 41.7261C52.3088 43.0144 51.2467 45.5663 50.2989 48.0747C49.3787 50.5102 48.605 52.7981 48.3438 53.5933C48.3387 53.614 48.3343 53.635 48.3292 53.6558C48.3226 53.6824 48.3153 53.7092 48.3087 53.7358C46.868 61.1247 40.3404 66.48 32.838 66.48C25.3651 66.4798 18.8397 61.1548 17.3184 53.8022C17.317 53.7962 17.3157 53.7905 17.3145 53.7856C17.3135 53.7814 17.3124 53.7754 17.3116 53.772C17.311 53.7695 17.3101 53.7673 17.3096 53.7651L17.3038 53.7534L17.2803 53.6831C17.1196 53.1978 16.3489 50.8911 15.3956 48.3511C14.4285 45.7745 13.317 43.0788 12.4805 41.7437C11.6824 40.4692 10.5997 39.7602 9.54108 39.3481L7.74323 38.6489L9.31549 37.5308C10.8818 36.4179 12.8168 35.8179 14.8399 35.8179C16.1262 35.8179 17.4089 36.073 18.544 36.5786L18.5518 36.5825L18.5596 36.5854C18.6419 36.6237 18.704 36.6362 18.7706 36.6362C18.8543 36.6362 18.9699 36.6072 19.1036 36.5337C19.2651 36.4114 19.3555 36.233 19.3555 36.0405V15.7329C19.3555 13.4645 21.1791 11.6187 23.4493 11.6187C25.7195 11.6187 27.543 13.4645 27.543 15.7329C27.5431 16.0642 27.8154 16.3276 28.128 16.3276C28.4404 16.3274 28.7119 16.0641 28.712 15.7329V11.6616C28.712 9.39323 30.5356 7.54741 32.8057 7.54736Z",
    fill: "#FFF4E2",
    stroke: "#003B75",
    strokeWidth: 2.07997
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.663 35.8896C34.4919 35.3266 37.6124 36.1194 40.079 37.4189C42.5554 38.7238 44.3887 40.5488 45.6063 42.0586C46.2136 42.8117 46.6639 43.4813 46.9608 43.96C47.0058 44.0325 47.0459 44.1017 47.0839 44.165C36.6734 51.2185 29.2101 50.5566 24.368 48.2529C21.8764 47.0675 20.0299 45.4254 18.8046 44.0742C18.1928 43.3996 17.7384 42.8009 17.4393 42.374C17.4038 42.3232 17.3728 42.2732 17.3417 42.2275C22.5189 38.2664 26.9475 36.4361 30.663 35.8896Z",
    fill: "#003B75",
    stroke: "#1C1C35",
    strokeWidth: 1.42972
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6547 41.5573C37.1792 38.542 34.2069 36.4621 31.1916 36.9376C28.1763 37.4132 26.0964 40.3855 26.5719 43.4008C27.0475 46.416 30.0198 48.4959 33.0351 48.0204C36.0504 47.5448 38.1303 44.5726 37.6547 41.5573Z",
    fill: "#003B75",
    stroke: "#F1ECE2",
    strokeWidth: 1.85964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0912 49.2063L27.4379 45.5579",
    stroke: "#003B75",
    strokeWidth: 1.85964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5834 31.7207L36.2438 36.4505",
    stroke: "#003B75",
    strokeWidth: 1.15082,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2682 48.0283L30.284 52.8986",
    stroke: "#003B75",
    strokeWidth: 1.85964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.155 36.2428L33.359 30.6447",
    stroke: "#003B75",
    strokeWidth: 1.15082,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3224 52.378L35.1923 47.1546",
    stroke: "#003B75",
    strokeWidth: 1.85964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7411 30.6196L28.3424 36.1093",
    stroke: "#003B75",
    strokeWidth: 1.15082,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9869 48.6016L37.462 44.0729",
    stroke: "#003B75",
    strokeWidth: 1.85964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8073 32.6101L26.4398 36.4318",
    stroke: "#003B75",
    strokeWidth: 1.15082,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5533 42.2729L37.7536 42.3862",
    stroke: "#F1ECE2",
    strokeWidth: 1.85964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoheader);
export default __webpack_public_path__ + "static/media/logoheader.0baf193cf5975a01cc3ab67e54f505d5.svg";
export { ForwardRef as ReactComponent };